"use client";

import { useState } from "react";

import type { Dispatch, ReactElement, SetStateAction } from "react";

type Props = {
  children: (
    bool: boolean,
    setBool: Dispatch<SetStateAction<boolean>>,
  ) => ReactElement;
};

export function Toggle({ children }: Props) {
  const [bool, setBool] = useState(false);

  return children(bool, setBool);
}
